import { Component, DoCheck, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { AppSettings } from '../../../app.settings';
import { SessionService } from '../../../services/session/session.service';
import { ScopedAccessService } from '../../../services/scoped-access/scoped-access.service';
import { exactScopedTarget, ScopedCompany } from '../../../services/scoped-access/scoped-access.models';
import { ScopedAccessState } from '../../../services/scoped-access/scoped-access.state';

@Component({
  selector: 'app-manage-scoped-access-dialog',
  templateUrl: './manage-scoped-access-dialog.component.html',
  styleUrls: ['./manage-scoped-access-dialog.component.scss'],
})
export class ManageScopedAccessDialogComponent implements OnInit, OnDestroy, DoCheck {
  readonly state: ScopedAccessState;
  readonly user: {id: string; firstName: string; lastName: string; email: string};
  readonly companySearch = new UntypedFormControl('');

  constructor(public dialogRef: MatDialogRef<ManageScopedAccessDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {user: {id: string; firstName: string; lastName: string; email: string}},
              private session: SessionService, api: ScopedAccessService) {
    this.user = Object.freeze({id: data.user.id, firstName: data.user.firstName, lastName: data.user.lastName, email: data.user.email});
    const context = this.context();
    const sessionCurrent = this.session.captureSessionContext();
    this.state = new ScopedAccessState(this.user.id, api, current => api.companies(current),
      () => sessionCurrent() && exactScopedTarget(this.session, this.user.id) && this.data.user.id === this.user.id && context === this.context());
  }
  ngOnInit(): void { void this.state.initialize(); }
  ngDoCheck(): void { this.state.checkContext(); }
  ngOnDestroy(): void { this.state.destroy(); }
  close(): void { this.state.destroy(); this.dialogRef.close(); }
  get filteredCompanies(): ScopedCompany[] {
    const search = String(this.companySearch.value || '').toLowerCase();
    return this.state.companies.filter(c => `${c.name} ${c.id}`.toLowerCase().includes(search));
  }
  private context(): string {
    const token = this.session.decodeJWTToken();
    return JSON.stringify([AppSettings.getEndpoint(), token?.userId, token?.sessionAbsoluteExp, token?.permissionLevel]);
  }
}
